import React from 'react'
import Card from './Card'

function Scrolling(props) {
  return (
    <>

      <h2 className="text-center mt-5">Our Services</h2>
      <div className='top-card-box-holder'>
        <div className="container d-flex card-container my-3">
          <Card cardTitle={"Notes"} cardDesc={"Download handwritten Notes in English & Hindi."} imgLink={"./image/i06.jpeg"} setDisplay={props.setDisplay} />
          <Card cardTitle={"Previous Year Papers"} cardDesc={"Last Year BTEUP Question Papers"} imgLink={"./image/i03.jpeg"} setDisplay={props.setDisplay} />
          <Card cardTitle={"Syllabus"} cardDesc={"Download Syllabus of Your Desired Subject"} imgLink={"./image/i02.jpeg"} setDisplay={props.setDisplay} />
          <Card cardTitle={"Important Topics"} cardDesc={"Download Important Topics for Fast Revision"} imgLink={"./image/i04.jpeg"} setDisplay={props.setDisplay} />
          <Card cardTitle={"Video Lectures"} cardDesc={"Videos on Youtube by TheSmartEdu4u"} imgLink={"./image/i01.jpeg"} setDisplay={props.setDisplay} />
        </div>
      </div>

    </>
  )
}

export default Scrolling